const PATH = 'fe.components.measure.home.filters';

const messages = {
  classVersion: {
    key: `${PATH}.class_version`,
    defaultValue: 'CLASS Version'
  },
  ageLevel: {
    key: `${PATH}.age_level`,
    defaultValue: 'Age Level'
  },
  formality: {
    key: `${PATH}.formality`,
    defaultValue: 'Formality'
  },
  formal: {
    key: `${PATH}.formal`,
    defaultValue: 'Formal'
  },
  informal: {
    key: `${PATH}.informal`,
    defaultValue: 'Informal'
  },
  clear: {
    key: `${PATH}.clear`,
    defaultValue: 'Clear Search'
  },
  hierarchy: {
    key: `${PATH}.hierarchy`,
    defaultValue: 'Hierarchy'
  },
  observers: {
    key: `${PATH}.observers`,
    defaultValue: 'Observers'
  }
};

export default messages;
